<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <div style="height: 40px; font-size: 19px; font-weight: bold; color: #fff; margin-bottom: 15px;">正略智研</div>
          <p>信息化项目造价咨询专家</p>
        </div>
        <div class="footer-nav">
          <div class="footer-nav-col">
            <h4>核心业务</h4>
            <ul>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=industrial'" @click.prevent="navigateWithTab('#core-business', 'industrial')" @keypress.enter.prevent="navigateWithTab('#core-business', 'industrial')">信息化项目造价咨询</a>
              </router-link></li>
               <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=xxxtsjzx'" @click.prevent="navigateWithTab('#core-business', 'xxxtsjzx')" @keypress.enter.prevent="navigateWithTab('#core-business', 'xxxtsjzx')">信息系统审计咨询</a>
              </router-link></li>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=building'" @click.prevent="navigateWithTab('#core-business', 'building')" @keypress.enter.prevent="navigateWithTab('#core-business', 'building')">工程项目造价咨询</a>
              </router-link></li>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=energy'" @click.prevent="navigateWithTab('#core-business', 'energy')" @keypress.enter.prevent="navigateWithTab('#core-business', 'energy')">信息系统监理</a>
              </router-link></li>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=gczxfw'" @click.prevent="navigateWithTab('#core-business', 'gczxfw')" @keypress.enter.prevent="navigateWithTab('#core-business', 'gczxfw')">工程咨询服务</a>
              </router-link></li>
               <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#core-business?tab=rjkf'" @click.prevent="navigateWithTab('#core-business', 'rjkf')" @keypress.enter.prevent="navigateWithTab('#core-business', 'rjkf')">软件开发</a>
              </router-link></li>
            </ul>
          </div>
          <div class="footer-nav-col">
            <h4>行业案例</h4>
            <ul>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#industry-cases'" @click.prevent="navigateWithHyal('#industry-cases', 'xxhxmzjzx')" @keypress.enter.prevent="navigateWithHyal('#industry-cases', 'xxhxmzjzx')">信息化项目造价咨询</a>
              </router-link></li>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#industry-cases'" @click.prevent="navigateWithHyal('#industry-cases', 'gzxmzjzx')" @keypress.enter.prevent="navigateWithHyal('#industry-cases', 'gzxmzjzx')">工程项目造价咨询</a>
              </router-link></li>
              <li><router-link to="/" v-slot="{ href }" custom>
                <a :href="href + '#industry-cases'" @click.prevent="navigateWithHyal('#industry-cases', 'kxxyjbg')" @keypress.enter.prevent="navigateWithHyal('#industry-cases', 'kxxyjbg')">可行性研究报告</a>
              </router-link></li>
            </ul>
          </div>
          <div class="footer-nav-col">
            <h4>关于我们</h4>
            <ul>
              <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=introduction'" @click.prevent="navigateWithAbout('#abouttop', 'introduction')" @keypress.enter.prevent="navigateWithAbout('/about', 'introduction')">公司简介</a>
              </router-link></li>
               <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=culture'" @click.prevent="navigateWithAbout('#abouttop', 'culture')" @keypress.enter.prevent="navigateWithAbout('/about', 'culture')">企业文化</a>
              </router-link></li>
               <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=introduction2'" @click.prevent="navigateWithAbout('#abouttop', 'introduction2')" @keypress.enter.prevent="navigateWithAbout('/about', 'introduction2')">技术实力</a>
              </router-link></li>
               <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=history'" @click.prevent="navigateWithAbout('#abouttop', 'history')" @keypress.enter.prevent="navigateWithAbout('/about', 'history')">发展历程</a>
              </router-link></li>
               <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=honors'" @click.prevent="navigateWithAbout('#abouttop', 'honors')" @keypress.enter.prevent="navigateWithAbout('/about', 'honors')">资质荣誉</a>
              </router-link></li>
               <li><router-link to="/about" v-slot="{ href }" custom>
                <a :href="href + '?tab=team'" @click.prevent="navigateWithAbout('#abouttop', 'team')" @keypress.enter.prevent="navigateWithAbout('/about', 'team')">公司剪影</a>
              </router-link></li>
            </ul>
          </div>
          <div class="footer-nav-col2">
            <h4>联系我们</h4>
            <div class="contact-info">
              <p><img src="/img/bluePhone.svg">13525947399</p>
              <p><img src="/img/blueEmail.svg">hnzlzygczx@163.com</p>
              <p><img src="/img/address.svg">河南省洛阳市西工区数码大厦</p>
              <p style="padding-left: 23px;">河南省郑州市金水区瀚海爱特中心</p>
            </div>
          </div>
        </div>
        <div class="footer-qrcode">
          <div class="qrcode-item">
            <div style="width: 100px; height: 100px; background-color: #fff; display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
              <img src="/img/ewm.png" alt="二维码">
            </div>
            <p>扫码咨询</p>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
<!--        <p>&copy; 2023-2025 河南正略智研工程咨询有限公司 版权所有 <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备2025124264号</a></p>-->
        <p>&copy; 2023-2026 河南正略智研工程咨询有限公司 版权所有 <span class="footer-record"><img style="width: 15px ; height: 16px" src="/img/jh.png" alt="国徽"> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41030302000820" rel="noreferrer" target="_blank">豫公网安备41030302000820号</a > <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">豫ICP备2025124264号-1</a ></span></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    navigateWithTab(hash, tab) {
      this.$router.push({
        path: '/',
        hash: hash,
        query: { tab: tab }
      });
    },
    navigateWithHyal(hash, tab) {
      this.$router.push({
        path: '/',
        hash: hash,
        query: { hyal: tab }
      });
    },
    navigateWithAbout(hash, tab) {
      this.$router.push({
        path: '/about',
        hash: hash,
        query: { tab: tab }
      });
    },

  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 60px 0 0;
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-top {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }
  
  .footer-logo {
    width: 20%;
    
    img {
      height: 40px;
      margin-bottom: 15px;
    }
    
    p {
      color: #ccc;
      font-size: 14px;
    }
  }
  
  .footer-nav {
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    
    @media (max-width: 768px) {
      width: 100%;
      justify-content: center;
    }
    
    .footer-nav-col {
      width: 20%;
      padding-right: 20px;
      
      @media (max-width: 768px) {
        width: 33.33%;
        padding-right: 0;
        text-align: center;
      }
      
      h4 {
        font-size: 18px;
        margin-bottom: 20px;
        position: relative;
        padding-bottom: 10px;
        
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 2px;
          background-color: #1ebec8;
          
          @media (max-width: 768px) {
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      
      ul li {
        margin-bottom: 10px;
        
        a {
          color: #ccc;
          font-size: 14px;
          transition: all 0.3s;
          
          &:hover {
            color: #1ebec8;
          }
        }
      }
      
      .contact-info {
        color: #ccc;
        
        p {
          margin-bottom: 10px;
          font-size: 14px;
          
        i { 
          margin-right: 10px;
          color: #1ebec8;
          }
        }
      }
    }
    .footer-nav-col2 {
      width: 35%;
      padding-right: 20px;
      @media (max-width: 768px) {
        width: 33.33%;
        padding-right: 0;
        text-align: center;
      }

      h4 {
        font-size: 18px;
        margin-bottom: 20px;
        position: relative;
        padding-bottom: 10px;

        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 30px;
          height: 2px;
          background-color: #1ebec8;

           @media (max-width: 768px) {
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }

      ul li {
        margin-bottom: 10px;

        a {
          color: #ccc;
          font-size: 14px;
          transition: all 0.3s;

          &:hover {
            color: #1ebec8;
          }
        }
      }

      .contact-info {
        color: #ccc;

        p {
          margin-bottom: 10px;
          font-size: 14px;
          img {
            margin-right: 10px;
            width: 15px;
            height: 15px;  
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  
  .footer-qrcode {
    width: 10%;
    text-align: right;
    
    .qrcode-item {
      display: inline-block;
      text-align: center;
      
      img {
        width: 100px;
        height: 100px;
        margin-bottom: 10px;
      }
      
      p {
        color: #ccc;
        font-size: 14px;
      }
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px 0;
    text-align: center;
    
    p {
        color: #999;
        font-size: 14px;
        font-size: 12px;
        line-height: 1.5;
        
        .footer-record {
          display: inline;
        }
        
        @media (max-width: 768px) {
          .footer-record {
            display: block;
            margin-top: 5px;
          }
        }
      }
    
    
    img {
      vertical-align: middle;
      
      @media (max-width: 768px) {
        width: 12px !important;
        height: 13px !important;
      }
    }
    
    a {
      @media (max-width: 768px) {
        display: inline-block;
        margin-top: 5px;
      }
    }
  }
  
  // 响应式样式
  @media (max-width: 992px) {
    .footer-logo,
    .footer-qrcode {
      width: 100%;
      text-align: center;
      margin-bottom: 30px;
    }
    
    .footer-nav {
      width: 100%;
      
      .footer-nav-col,.footer-nav-col2 {
        width: 90%;
        margin-bottom: 30px;
      }
    }
  }
  
  @media (max-width: 576px) {
    .footer-nav .footer-nav-col {
      width: 100%;
    }
  }
}

a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: #409EFF;
}
</style>